export default __webpack_public_path__ + "static/media/powerhouse.2419ed65.png";